export default {
  locale: 'it',
  messages: {
    actions: 'Azioni',
    add: 'Aggiungi',
    addressAddNew: 'Aggiungi un nuovo indirizzo',
    addressChangeAddress: 'Scegli un altro indirizzo',
    addressCity: 'Città',
    addressCountry: 'Paese',
    addressDeleteConfirmMessage: 'Sei sicuro di voler eliminare questo indirizzo?',
    addressDeleteConfirmTitle: 'Eliminazione di un indirizzo',
    addressDeleteSuccess: 'Indirizzo eliminato!',
    addressEdit: 'Modifica l\'indirizzo',
    addressesMyManage: 'Gestisci i miei indirizzi',
    addressInvoice: 'Indirizzo di fatturazione',
    addressInvoiceCountry: 'Paese di fatturazione',
    addressInvoiceSameAsShippingLabel: 'I dati di fatturazione corrispondono a quelli di consegna?',
    addressInvoiceUsedFor: 'Imposta come indirizzo di fatturazione',
    addressInvoiceUsedForSuccess: 'Indirizzo di fatturazione aggiornato!',
    addressLabel: 'Titolo dell\'indirizzo (es: Casa)',
    addressMy: 'I miei indirizzi',
    addressMyViewButton: 'Visualizza i miei indirizzi',
    addressName: 'Nome e cognome del destinatario',
    addressNameAlt: 'Nome dell\'azienda (se la consegna è al lavoro)',
    addressNoItems: 'Non hai ancora salvato alcun indirizzo!',
    addressPhone: 'Telefono (utile per la consegna)',
    addressPostalCode: 'Codice postale',
    addressRegion: 'Regione',
    addressSavedCountryError: 'Questo paese non è autorizzato!',
    addressSavedSuccess: 'Indirizzo salvato!',
    addressSelectOptions: 'Scegli un indirizzo',
    addressShipping: 'Indirizzo di consegna',
    addressShippingCountry: 'Paese di consegna',
    addressStreet1: 'Indirizzo',
    addressStreet2: '"Appartamento',
    addressUserCount: `Hai {count} {count, plural,
    =0 {indirizzo}
    =1 {indirizzo}
    other {indirizzi}
    } {count, plural,
    =0 {registrato}
    =1 {registrato}
    other {registrati}
    } nel tuo account.`,
    administrationTitle: 'Amministrazione',
    alertFetchApiError: 'Il server è attualmente offline...',
    alertFormRequiredFieldsError: '"Per favore',
    alertGenericError: 'Si è verificato un errore! Riprova più tardi...',
    alertJsonParseError: 'Il server ha risposto in modo errato...',
    alertUnauthorized: '"La tua sessione è scaduta! Per favore',
    alertContactError: '"Impossibile inviare il tuo messaggio! Per favore',
    alertContactSuccess: 'Ricevuto con successo!',
    alertUserAlreadyExists: 'Esiste già un account con questa email!',
    alertUserRegisterSuccess: '"Benvenuto! Per favore',
    app404ErrorTitle: 'Strada sbagliata...',
    appAccessButton: 'Vai a {app}',
    appAdvantagesFabrication: 'Prodotto in Europa',
    appAdvantagesFreeShipping: 'Spedizione gratuita in Europa',
    appAdvantagesInternationalShipping: 'Spedizione internazionale',
    appAdvantagesSecurePayment: 'Pagamento sicuro',
    appConditionsAcceptTitle: 'Condizioni generali di utilizzo',
    appConditionsCheckError: 'Si prega di spuntare per aver preso visione delle condizioni generali di utilizzo!',
    appConditionsCheckLabel: 'Ho letto e accetto le condizioni generali di utilizzo',
    appConditionsCheckSuccess: 'Ricevuto con successo!',
    appConditionsUpdateDate: 'Ultimo aggiornamento il {date}',
    appCookieConsentText: '"Continuando la navigazione su questo sito',
    appCookieConsentPrivacyLink: 'Consulta la nostra politica sulla privacy',
    appForceUpdateApp: 'Forza l\'aggiornamento dell\'applicazione',
    appHome: 'Home',
    appVersionCurrent: 'Versione attuale dell\'applicazione: {versione}',
    back: 'Indietro',
    by: 'da',
    cancel: 'Annulla',
    cartAddToButton: 'Aggiungi al carrello',
    cartBackToHomeButton: 'Continua sul sito',
    cartConfirmationText: '"Riceverai un\'email di conferma',
    cartConfirmationTitle: '"Grazie ! <br />Il tuo ordine <a href={link} class=text-warning text-underline"">{numero_ordine}</a> è stato confermato."""',
    cartConfirmationSubText: 'Vieni a condividere sui social media',
    cartDeliveryTitle: 'Consegna',
    cartEmptyError: 'Il tuo carrello è vuoto...',
    cartInvoiceAddressSelectionTitle: 'Seleziona il tuo indirizzo di fatturazione',
    cartItemProductPackPriceAlertTitle: 'Prezzi decrescenti',
    cartItemProductPackPriceAlertText: 'Aumenta il numero di scatole per usufruire di tariffe vantaggiose',
    cartLegalMentionText: '"Convalidando il tuo ordine riconosci di aver preso visione delle <a href={link}"" target=""_blank"">CGV</a> e ne accetti i termini"""',
    cartNextButton: 'Avanti',
    cartNotValidError: '"Per favore',
    cartPayButton: 'Effettua il pagamento',
    cartPaymentBankTransferLabel: 'Paga con bonifico bancario',
    cartPaymentCreditCardLabel: 'Paga con carta di credito',
    cartPaymentPaypalLabel: 'Paga con Paypal',
    cartPendinpPaymentText: 'Non ci resta che il tuo pagamento per elaborare il tuo ordine...',
    cartStepPaymentTitle: 'Il tuo pagamento',
    cartStepPaymentInfoText: '"Quasi finito',
    cartStepPreviewTitle: 'Il tuo carrello',
    cartStepPreviewInfoText: 'Eccoti nel tuo carrello.<br />Considera le nostre tariffe decrescenti.',
    cartStepShippingTitle: 'Le tue informazioni',
    cartStepShippingInfoText: 'Verifica il tuo indirizzo di consegna <br />e tutti i dettagli necessari per il corriere',
    cartShippingAddressMissingError: 'Non hai inserito il tuo indirizzo di consegna!',
    cartShippingAddressSelectionTitle: 'Seleziona il tuo indirizzo di consegna',
    cartShippingCalculatedTitle: 'Spedizione e IVA',
    cartShippingCalculationText: 'Indica il tuo paese di consegna',
    cartShippingCalculationTitle: 'Calcola le tue spese di spedizione e IVA.',
    cartShippingCalculationListButton: 'Paese di consegna',
    cartShippingSetAlert: 'Desideri ricevere la consegna in {paese}',
    cartShippingUnavailableAlert: 'Non possiamo consegnare nella tua regione!',
    cartShippingUnavailableLink: 'Visualizza l\'elenco dei paesi',
    cartShippingValidateDetails: 'Conferma i dettagli di consegna',
    cartTotalNotSet: 'Non applicabile',
    cartTotalShipping: 'Spedizione',
    cartTotalShippingFree: 'Gratuita',
    cartTotalSubTotal: 'Totale parziale',
    cartTotalTax: 'IVA',
    cartTotalTaxNotSet: 'Seleziona il tuo paese di consegna',
    cartTotalTotal: 'Totale',
    cartVoucherApplyTitle: 'Codice promozionale',
    checkToggler: 'Seleziona Tutto/Deseleziona Tutto',
    choose: 'Seleziona',
    close: 'Chiudi',
    cms: 'CMS',
    cmsContentEdit: 'Modifica del contenuto',
    cmsContentIsActive: 'Contenuto attivo ?',
    cmsContentModelLabel: 'Modello',
    cmsContentSlug: 'Percorso',
    cmsContentTitle: 'Titolo',
    cmsContentTranslations: 'Traduzioni',
    cmsContentTypeLabel: 'Tipo di contenuto',
    cmsPageSeoDescription: 'Descrizione SEO',
    cmsPageSeoKeywords: 'Parole chiave SEO',
    cmsPageSeoTitle: 'Titolo SEO',
    cmsPanelIsTemplate: 'Incluso nel tema',
    configuration: 'Configurazione',
    contactByEmail: 'Per email',
    contactFormIdentityTitle: 'Identità',
    contactInfoText: 'Per qualsiasi domanda sul nostro prodotto o sul tuo ordine',
    contactNeedHelpTitle: 'Hai bisogno di aiuto ?',
    contactPageButton: 'Invia',
    contactPageTitle: 'Contattaci',
    contactPageText1: 'Hai bisogno di aiuto ? Di informazioni ? Siamo qui per aiutarti!',
    contactSendButton: 'Invia il messaggio',
    contactTitle: 'Contatto',
    contactUsByPhone: 'Contattaci al',
    continue: 'Continua',
    country: 'Paese',
    countryFillPlaceholder: '"Inserisci un paese e premi invio"""""',
    countrySelectPlaceholder: 'Seleziona un paese',
    dateActivated: 'Data di attivazione',
    dateCreated: 'Data di creazione',
    dateCreation: 'Data di creazione',
    dateLastCguAccept: 'Data dell\'ultima convalida delle CGU',
    dateLastEdit: 'Data dell\'ultima modifica',
    dateLastLogin: 'Data dell\'ultima connessione',
    dateLastOrder: 'Data dell\'ultimo ordine',
    dateSelect: 'Seleziona una data',
    dateSelectPlaceholder: 'Fai clic qui per selezionare una data...',
    dashboardTitle: 'Dashboard',
    date: 'Data',
    dateThe: 'il {date}',
    days: 'Giorno(i)',
    delete: 'Rimuovi',
    deleteRequestError: 'Errore di rimozione !',
    deleteRequestSuccess: 'Rimosso !',
    domain: 'Dominio',
    download: 'Scarica',
    edit: 'Modifica',
    editViewAdvanced: 'Modifica avanzata',
    editViewSimplified: 'Modifica semplificata',
    elementsCount: '"{count} {count',
    elementNoItems: 'Nessun elemento',
    example: 'Esempio',
    examples: 'Esempi',
    file: 'File',
    fileDeleteError: 'Impossibile eliminare questo file',
    fileDeleteSuccess: 'File eliminato !',
    files: 'Impossibile caricare questo file !',
    fileUploadError: 'Il caricamento del file inizierà al salvataggio.',
    fileUploadProcessStartOnSave: 'File caricato !',
    fileUploadRestrictionTypeError: 'Formato del file non accettato ! Consentito: {tipi}',
    filtersTitle: 'Filtri',
    finish: 'Termina',
    formFieldRequired: 'Questo campo è obbligatorio !',
    formFieldValidEmail: 'Si prega di inserire un\'email valida !',
    generalInformation: 'Informazioni generali',
    help: 'Aiuto',
    hours: 'Ore',
    imageDeleteError: 'Impossibile eliminare questa immagine !',
    imageDeleteSuccess: 'Immagine eliminata !',
    imageUploadError: 'Impossibile caricare questa immagine',
    imageUploadRestrictionSize: 'L\'immagine deve avere un formato massimo di {formato}',
    imageUploadRestrictionType: 'L\'immagine deve essere in {tipi}',
    imageUploadRestrictionTypeError: 'Formato immagine non accettato ! Consentito: {tipi}',
    import: 'Importa',
    importerFileInfo: 'Seleziona un file CSV (Valori separati da virgola)',
    importerFileHelp: '"Puoi generare un file CSV utilizzando il tuo software di foglio di calcolo (Excel',
    importerNoItemsAlert: 'Nessun elemento da importare',
    importerTitle: 'Importa dati',
    importerFileButton: 'Importa dati',
    importModelDownloadButton: 'Scarica il modello',
    importRequestError: 'Si è verificato un errore durante l\'importazione !',
    importRequestSomeFailAlert: 'Uno o più voci non sono state importate !',
    importRequestSuccess: 'Dati importati !',
    information: 'Informazione',
    informationsDetails: 'Dettagli',
    informationsGeneral: 'Informazioni generali',
    isActive: 'Attivo ?',
    isPublic: 'Pubblico ?',
    isUnlimited: 'Illimitato ?',
    label: 'Titolo',
    langDE: 'Deutsh',
    langEN: 'Inglese',
    langES: 'Spagnolo',
    langFR: 'Francese',
    language: 'Lingua',
    learnMore: 'Ulteriori informazioni',
    listTitle: 'Elenco',
    loading: 'Caricamento...',
    loadMore: 'Carica altro...',
    logo: 'Logo',
    matter: 'Materiale',
    minutes: 'Minuto(i)',
    name: 'Nome',
    next: 'Avanti',
    newsletterInfoText: '"Vuoi saperne di più',
    newsletterTitle: 'Newsletter',
    no: 'No',
    options: 'Opzioni',
    orderAdd: 'Aggiungi un ordine',
    orderBuyButton: 'Acquista',
    orderCartLink: 'Carrello',
    orderCreationError: '"Non possiamo creare il tuo ordine al momento... Per favore',
    orderCreationProcessing: 'Stiamo creando il tuo ordine...',
    orderFlags: 'Bandiere',
    orderItems: 'Contenuto',
    orderInformationDetails: 'Dettagli dell\'ordine',
    orderInvoice: 'Fattura',
    orderInvoiceDate: 'Data fattura',
    orderInvoiceNumber: 'Numero fattura',
    orderInvoicePrintButton: 'Stampa fattura',
    orderMy: 'Il mio ordine',
    ordersMyViewButton: 'Vedi i miei ordini',
    ordersMy: 'I miei ordini',
    orderNoElements: 'Non hai ancora effettuato ordini !',
    orderPaymentFinishTitle: 'Prosegui con il pagamento',
    orderPaymentMethod: 'Metodo di pagamento',
    orderPaymentMethodBanktransfer: 'Bonifico bancario',
    orderPaymentMethodCreditcard: 'Carta di credito',
    orderPaymentMethodPaypal: 'Paypal',
    orderPaymentProcessButton: 'Effettua il pagamento',
    orderPaymentProcessing: 'Stiamo raccogliendo il tuo pagamento...',
    orderPayments: 'Pagamenti',
    orderPaymentStatusPending: 'In attesa',
    orderPaymentStatusComplete: 'Completato',
    orderPaymentUnavailableAlert: '"Metodo di pagamento non disponibile... Per favore',
    orderPaymentValidButton: 'Convalida pagamento',
    orderPaymentValidSuccess: 'Pagamento convalidato',
    orderProductAdd: 'Aggiungi un prodotto',
    orderReOrderButton: 'Rinnova il mio ordine',
    orders: 'Ordini',
    orderShippings: 'Spedizioni',
    orderStatusArchived: 'Archiviato',
    orderStatusCanceled: 'Annullato',
    orderStatusComplete: 'Completato',
    orderStatusOnpreparation: 'In preparazione',
    orderStatusPendingpayment: 'In attesa di pagamento',
    orderStatusShipped: 'Spedito',
    orderSubscribeButton: 'Iscriviti',
    orderTotal: 'Totale',
    orderUserCount: '"Tu hai {count} {count',
    orderWeight: 'Peso dell\'ordine',
    Page404ErrorTitle: 'Non abbiamo trovato ciò che stai cercando...',
    priceHT: 'Prezzo HT',
    priceTTC: 'Prezzo IVA inclusa',
    previous: 'Precedente',
    productAdd: 'Aggiungi un prodotto',
    productAddedSuccess: '{prodotto} aggiunto !',
    productCodeEAN: 'Codice EAN',
    productComposition: 'Composizione',
    productDescription: 'Descrizione',
    productDuplicateSuccess: 'Prodotto duplicato !',
    productEdit: 'Modifica prodotto',
    productImageSaveBeforeAlert: 'Devi salvare questo prodotto prima di aggiungere un\'immagine !',
    productName: 'Nome',
    productPackChoiceTitle: 'Scopri i nostri pacchetti',
    productPackFreeCount: '#ERROR!',
    productPackMonthlyConsumptionLabel: 'Consigliato per 1 mese',
    productPackUnitPrice: 'Per {prezzo}/scatola',
    productPriceInformation: 'Tariffe',
    products: 'Prodotti',
    productSelectOptions: 'Seleziona un prodotto',
    productSlug: 'Percorso',
    productSpoonLabel: 'Il misurino',
    productSpoonOffer: 'in regalo',
    productSubTotal: 'Prezzo IVA inclusa',
    productTaxCalculate: 'Calcola',
    productTaxRate: 'Aliquota fiscale',
    productTaxRateTaxCalculation: 'Oppure {amount}€ di IVA',
    productUnitLabel: 'scatola',
    productUnitCountLabel: '"{count} {count',
    quantity: 'Quantità',
    refresh: 'Aggiorna',
    remove: 'Rimuovi',
    retry: 'Ricomincia',
    reviewAddFirstReviewButton: 'Rilascia la tua recensione',
    reviewAddFirstReviewText: 'Ti piace il nostro prodotto ? Vuoi condividere la tua esperienza con i nostri clienti ? Condividi la tua esperienza ! Ci vorranno solo 2 minuti !',
    reviewAddFirstReviewTitle: 'Valuta il nostro prodotto !',
    reviewAddLoading: 'Stiamo registrando la tua opinione...',
    reviewAddSuccess: 'Abbiamo ricevuto correttamente la tua opinione ! Sarà visualizzata dopo la moderazione....',
    reviewAnswer: 'Risposta di Atremoplus',
    reviewFilterClear: 'Reimposta filtri',
    reviewFilterLabel: 'Ordina per testimonianza',
    reviewFilterLanguageLabel: 'Per lingua',
    reviewLink: 'Copia il link al tuo video',
    reviewLinkHelp: 'Registra il tuo video su Youtube (ad esempio) e poi copia il link del video nel campo sopra.',
    reviewLinkViewButton: 'Visualizza il link',
    reviewName: 'Nome e paese',
    reviews: 'Recensione',
    reviewScoreLabel: 'Scegli la tua valutazione',
    reviewSummaryButton: 'Scopri cosa dicono di noi',
    reviewSummaryTitle: '"I nostri clienti parlano meglio di noi',
    reviewText: 'Inserisci la tua recensione...',
    reviewTitle: 'Titolo della tua recensione',
    reviewTypeLinkLabel: 'Media',
    reviewTypeTextLabel: 'Testo',
    save: 'Salva',
    saveBeforeAlert: 'Si prega di salvare prima...',
    saveRequestError: 'Errore durante il salvataggio !',
    saveRequestSuccess: 'Salvato !',
    saving: 'Salvataggio...',
    searchFor: 'Cerca',
    seconds: 'Secondo(i)',
    selectAll: 'Seleziona Tutto',
    selectUnAll: 'Deseleziona Tutto',
    selectFile: 'Seleziona un file',
    selectImage: 'Seleziona un\'immagine',
    selectOptions: 'Seleziona un\'opzione',
    seoTitle: 'Complemento L-Dopa naturale',
    shippingFeeAmountLabel: 'Importo',
    shippingFeeCarrierLabel: 'Trasportatore',
    shippingFeeCountriesLabel: 'Paesi selezionati',
    shippingFeeExcludeDepartmentInfo: '"Separa i codici con una virgola (',
    shippingFeeExcludeDepartmentLabel: 'Escludi i codici postali',
    shippingFeeFreeThresholdInfo: 'Imposta questo valore su 0 per disattivare la spedizione gratuita',
    shippingFeeFreeThresholdLabel: 'Importo minimo per applicare la spedizione gratuita',
    shippingFeeHasExcludeConditions: 'Con eccezioni',
    shippingFees: 'Spese di spedizione',
    shippingFeeTrackingUrlInfo: 'Puoi aggiungere \'{trackingNumber}\' all\'url per includere automaticamente il numero di tracciamento.',
    shippingFeeTrackingUrlLabel: 'Url di tracciamento',
    status: 'Stato',
    stepTitle: 'Passaggio {passaggio}',
    subscription: 'Abbonamento',
    subscriptionCartButton: 'Mi abbono senza impegno',
    subscriptionCartText: '"Pensa all\'abbonamento: scegli il tuo periodo',
    subscriptionCancelSuccess: 'Il tuo abbonamento è stato cancellato !',
    subscriptionCancelSuccessDeffered: 'Cancelleremo il tuo abbonamento al più presto !',
    subscriptionConfigurationPackTitle: 'Scelta del pacchetto',
    subscriptionConfigurationPeriodTitle: 'Scelta della frequenza',
    subscriptionConfigurationTitle: 'Configura il tuo abbonamento',
    subscriptionCreateButton: 'Mi abbono senza impegno',
    subscriptionPeriod1Month: '1 mese',
    subscriptionPeriod6Week: '6 settimane',
    subscriptionPeriod2Month: '2 mesi',
    subscriptionRemoveButton: 'Non desidero abbonarmi al momento',
    subscriptionResumeText: '"Hai scelto un abbonamento di {count} {count',
    subscriptionResumeText2: '"Abbonamento di {count} {count',
    subscriptionResumeTitle: 'Il tuo abbonamento',
    subscriptionStopButton: 'Interrompi l\'abbonamento',
    submit: 'Invia',
    switch: 'Cambia',
    switchLanguage: 'Cambia lingua',
    tableMassActions: 'Azioni raggruppate',
    tableRefreshSuccessError: 'Errore di sincronizzazione !',
    tableRefreshSuccessAlert: 'Sincronizzato !',
    tableSelection: '"{count} {count',
    tag: 'Parola chiave',
    tags: 'Parole chiave',
    tagFillPlaceholder: '"Inserisci una parola chiave e premi Invio""..."""',
    taxes: 'Tasse',
    taxCountriesLabel: 'Paesi selezionati',
    taxHasCustomsFees: 'Spese doganali ?',
    taxHasCustomsFeesInfo: 'Con spese doganali',
    taxRate: 'IVA',
    taxRateLabel: 'Aliquota fiscale',
    taxThresholdLabel: 'Importo minimo per applicare l\'aliquota',
    time: 'Ora',
    timezone: 'Fuso orario',
    the: 'il',
    title: 'Titolo',
    total: 'Totale',
    type: 'Tipo',
    unit: 'Unità',
    user: 'Utente',
    userAccountDataProtection: 'Protezione dei dati',
    userAccountDataProtectionText1: '"Diamo molta importanza alla protezione dei tuoi dati personali',
    userAccountDataProtectionText2: 'Ti chiediamo solo informazioni necessarie al servizio e ci impegniamo a non comunicare mai a un servizio terzo o utilizzare i tuoi dati personali per scopi commerciali senza il tuo consenso.',
    userAccountDataProtectionText3: '"Se desideri recuperare i tuoi dati o utilizzare il tuo diritto alla portabilità dei dati',
    userAccountDelete: 'Elimina il mio account',
    userAccountDeleteBlockText: 'Non puoi eliminare il tuo account al momento !',
    userAccountDeleteButton: 'Elimina il mio account',
    userAccountDeleteConfirmMessage: 'Sei sicuro di voler eliminare definitivamente il tuo account ?',
    userAccountDeleteConfirmTitle: 'Elimina il mio account',
    userAccountDeleteError: 'Impossibile eliminare il tuo account !',
    userAccountDeleteSuccess: 'Il tuo account è stato eliminato ! A presto !',
    userAccountDeleteText: '"Eliminando il tuo account',
    userAccoutDetailsTitle: 'Le tue informazioni',
    userAccountEdit: 'Modifica il mio account',
    userAccountEditSuccess: 'Account aggiornato',
    userAccountExistTitle: 'Hai già un account ?',
    userAccountHistory: 'Cronologia',
    userAccountInfo: 'Le tue informazioni non saranno rese pubbliche !',
    userAccountInfoMyTitle: 'Le mie informazioni',
    userAccountGeneral: 'Generale',
    userAccountMy: 'Il mio account',
    userAccountPersonnalInformation: 'Le mie informazioni personali',
    userAccountPreferencesInformation: 'Le mie preferenze',
    userAccountResetError: 'Errore durante il ripristino dell\'account !',
    userAccountResetSuccess: 'Account ripristinato !',
    userActivityOnLine: 'Online',
    userAdd: 'Aggiungi utente',
    userAddNew: 'Aggiungi un nuovo utente',
    userChangePasswordSuccess: 'Password modificata !',
    userConfirmationCode: 'Codice di conferma ricevuto via email',
    userConfirmationCodeCheckButton: 'Ho ricevuto il codice per ripristinare la mia password',
    userConfirmationCodeError: 'Si prega di inserire il codice di conferma ! Controlla la tua casella di posta !',
    userConnectionInfo: 'Accedi al tuo account per confermare il tuo ordine e invitare i tuoi amici a partecipare !',
    userCustomerAccountLink: 'Cliente',
    userCustomerNewSubTitle: 'Informazioni e account cliente',
    userCustomerNewTitle: 'Nuovo cliente ?',
    userCustomerRegisteredSubTitle: 'Accedi',
    userCustomerRegisteredTitle: 'Cliente esistente',
    userDeleteConfirmation: '{utente} è stato eliminato !',
    userEdit: 'Modifica {utente}',
    userEdit2: 'Modifica utente',
    userEditPassword: 'Modifica la mia password',
    userEmail: 'Email',
    userEmailError: 'Il tuo indirizzo email non è corretto !',
    userEmailFillInfo: 'Inserisci il tuo indirizzo email',
    userEmailFormInfo: 'Inserisci la tua email per continuare',
    userEmailSwitch: 'Cambia l\'indirizzo email',
    userFillPlaceholder: 'Inserisci il nome di un utente...',
    userFirstName: 'Nome',
    userForgotPassword: 'Password dimenticata ?',
    userForgotPasswordRetryDateError: 'Non è possibile richiedere nuovamente una password. Si prega di controllare la tua casella di posta per recuperare il codice di conferma.',
    userGroupsTitle: 'Gruppi utente',
    userGroupsFillPlaceholder: 'Inserisci il nome di un gruppo...',
    userHistory: 'Monitoraggio utente {utente}',
    userIsActive: 'Attivo ?',
    userLastName: 'Nome',
    userLogin: 'Accesso',
    userLoginAction: 'Accedi',
    userLoginEmailSelected: 'Accesso con l\'indirizzo email: {email}',
    userLoginError: 'Credenziali non valide ! Si prega di riprovare...',
    userLoginFirstButton: 'Primo accesso ?',
    userLoginFirstText: 'Consulta la tua casella di posta per recuperare la tua password temporanea. Utilizza questa password per il tuo primo accesso. Potrai successivamente modificare la tua password.',
    userLoginIntro: '"Per favore',
    userLoginNoConnexion: 'Nessuna connessione',
    userLoginTitle: 'Accesso',
    userLogout: 'Disconnettiti',
    userName: 'Nome',
    userNewPassword: 'Nuova password',
    userOldPassword: 'Vecchia password',
    userOptions: 'Opzioni utente',
    userPassword: 'Password',
    userPasswordConfirmation: 'Conferma password',
    userPasswordConfirmationError: 'Si prega di inserire una conferma identica alla password !',
    userPasswordConfirmationRestriction: 'La conferma deve essere identica alla password inserita',
    userPasswordDisplayButton: 'Mostra password',
    userPasswordEdit: 'Modifica la mia password',
    userPasswordError: 'Inserisci la tua password personale. Confermala e clicca sul pulsante sottostante',
    userPasswordHideButton: 'Nascondere la password',
    userPasswordResetText: '"Per favore',
    userPasswordRestriction: 'La password deve contenere almeno 6 caratteri!',
    userPasswordRestrictionAlt: 'La password deve contenere almeno 6 caratteri!',
    userPasswordTemporaryCheckButton: 'Ho ricevuto correttamente la mia password temporanea',
    userPhone: 'Telefono',
    userProfileMy: 'Il mio profilo',
    userRegister: 'Crea il mio account',
    userReInitPassword: 'Reimposta la mia password',
    userRegisterError: 'Impossibile creare il tuo account! Controlla il tuo indirizzo email e riprova...',
    userRegisterSuccess: 'Congratulazioni! Il tuo account è stato creato!',
    userResetPasswordAccountButton: 'Reimposta la password dell\'account',
    userResetPasswordError: '"Impossibile reimpostare la tua password! Per favore',
    userResetPasswordInfo: 'Riceverai un codice nella tua casella di posta per reimpostare la tua password',
    userResetPasswordInfo2: 'Reimposta la tua password inserendo i seguenti campi:',
    userResetPasswordSuccess: 'La password è stata reimpostata con successo!',
    userRole: 'Ruolo',
    userRoleCustomer: 'Cliente',
    userRoleAdmin: 'Amministratore',
    users: 'Utenti',
    userSearchLabel: 'Digita un\'email o un nome utente',
    userSelectPlaceholder: 'Seleziona un utente',
    userSendNewAccountEmail: 'Invia un\'email per un nuovo account all\'utente',
    userSendNewAccountEmailSuccess: 'Utente avvisato!',
    usersList: 'Elenco degli utenti',
    userSubscribeNewsletterButton: 'Iscriviti',
    userSubscribeNewsletterConfirmation: 'Sei già iscritto alla nostra newsletter! Grazie!',
    userSubscribeNewsletterLabel: 'Vorrei ricevere offerte personalizzate da Atremoplus®',
    userNewsletterSubscribeError: '"Non siamo stati in grado di registrarvi tra i nostri abbonati',
    userNewsletterSubscribeSuccess: 'Complimenti! Sei stato iscritto con successo alla nostra newsletter!',
    userSwitch: 'Cambia utente',
    userValidForgotPasswordError: 'Impossibile inviare il codice di reimpostazione della password!',
    userValidForgotPasswordSuccess: 'Controlla la tua casella di posta per utilizzare il tuo codice di conferma e reimpostare la tua password!',
    valid: 'Conferma',
    view: 'Vedi',
    voucher: 'Codice sconto',
    voucherCodePlaceholder: 'Inserisci il tuo codice promozionale',
    voucherNotExistsError: 'Questo codice promozionale non esiste!',
    voucherNotValidError: 'Questo coupon non può essere applicato al tuo ordine!',
    vouchers: 'Sconti',
    yes: 'Sì',
    You: 'Tu',
    yourself: 'Tu',
  },
};
